import cx from "classnames";
import {
  Footer,
  Header,
  SideMenu,
  FlexBox,
  DashboardSideMenu,
  DocsSideMenu,
  DocsHeader,
  Loader,
  Image,
} from "components";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Slide, toast, ToastContainer } from "react-toastify";
import {
  AllApplicationsApi,
  GetUserDetailsApi,
  useAllApplicationsApiDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
} from "Slices";
import { ChangeHistory, history } from "utils";
import "./styles.scss";
import { ScreenProps } from "./types";
import Logo from "assets/logo.svg";

let timeout: any = null;
const Screen: React.FC<ScreenProps> = ({
  preventSlide = false,
  className,
  children,
  hasSideMenu,
  hasHeader,
  screenAnimationClass,
  customSideMenuVisibility,
  customSideMenuCallback,
  tabSelectCallback,
  scrolledToElement,
}) => {
  const dispatch = useDispatch();
  const [animationClass, setAnimationClass] = useState("");
  const [showScreen, setShowScreen] = useState(false);
  const [pullRightStart, setPullRightStart] = useState(0);
  const [pullRightMovement, setPullRightMovement] = useState(0);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [ifScroll, setIfScroll] = useState(false);
  const [menuOpened, setMenuOpened] = useState(false);
  const [hasTimerClass, setHasTimerClass] = useState(false);

  //Slices
  const userDetails = useGetUserDetailsApiDetails();
  const allApplications = useAllApplicationsApiDetails();
  const generalDetails = useGeneralDetails();

  const disableScrolling = () => {
    setTimeout(() => {
      setHasTimerClass(true);
    }, 500);
    var x = window.scrollX;
    var y = window.scrollY;
    window.onscroll = function () {
      window.scrollTo(x, y);
    };
  };

  const enableScrolling = () => {
    setHasTimerClass(false);
    window.onscroll = function () {};
  };

  useEffect(() => {
    menuOpened ? disableScrolling() : enableScrolling();
  }, [menuOpened]);

  useEffect(() => {
    window.onscroll = () => {
      const scrollPosition = window.pageYOffset;
      setIfScroll(scrollPosition > 0);
    };
  }, []);

  useEffect(() => {
    timeout = setTimeout(() => {
      if (screenAnimationClass) {
        setAnimationClass(screenAnimationClass);
      } else if (generalDetails?.screenClass) {
        setAnimationClass(generalDetails?.screenClass);
      } else {
        switch (history.action) {
          case "PUSH":
            setAnimationClass("fadeInRight");
            break;

          case "POP":
            setAnimationClass("fadeInLeft");
            break;

          default:
            break;
        }
      }
      setShowScreen(true);
    }, 0);
    return () => {
      timeout = null;
    };
  }, [generalDetails, screenAnimationClass]);

  return (
    <>
      <div className={cx(hasSideMenu && "has-side-menu", "docs-screen")}>
        <ToastContainer
          position={toast.POSITION.TOP_RIGHT}
          autoClose={2500}
          hideProgressBar={true}
          closeButton={false}
          transition={Slide}
          draggable={false}
          pauseOnFocusLoss={false}
          closeOnClick={true}
          className="toaster"
          limit={1}
        />
        {hasSideMenu && (
          <DocsSideMenu
            isOpened={menuOpened}
            tabSelectCallback={tabSelectCallback}
            scrolledToElement={{ ...scrolledToElement }}
          />
        )}

        <main className={cx(className, "pd-20")}>
          {window.screen.width <= 968 && (
            <>
              <Image src={Logo} className="mobile-docs-logo" />
              <div
                className={cx(
                  menuOpened && "hamburger-menu-opened",
                  hasTimerClass && "hamburger-menu-timer",
                  "curs-point hamburger-menu mr-t-10"
                )}
                onClick={() => {
                  setMenuOpened(!menuOpened);
                }}
              >
                <div />
                <div />
                <div />
              </div>
            </>
          )}
          {hasHeader && <DocsHeader />}
          {children}
        </main>
      </div>
      {/* <FlexBox
        className={cx(
          `main-screen animated ${animationClass}`,
          className,
          isMenuOpened && "menu-opened"
        )}
        justifyBetween={hasSideMenu}
      >
        <SideMenu
          isOpened={isMenuOpened}
          menuCloseCallback={(visible) => {
            setIsMenuOpened(visible);
            customSideMenuCallback && customSideMenuCallback(visible);
          }}
        />
        {showScreen && (
          <>
            {hasHeader && (
              <Header
                hamBurgerMenuClickCallback={() => {
                  setIsMenuOpened(!isMenuOpened);
                }}
                className={cx(ifScroll && "box-shadow", "pd-20")}
                // customBackAction={
                //   headerDetails.hasSideMenu
                //     ? () => setIsMenuOpened(false)
                //     : headerDetails.customBackAction
                //     ? () => headerDetails.customBackAction?.()
                //     : null
                // }
              />
            )}
            <div
              className={cx(
                hasSideMenu && "has-side-menu",
                "screen-children bg-white pd-20"
              )}
            >
              {children}
            </div>
          </>
        )}
      </FlexBox> */}
    </>
  );
};

export default Screen;
